import { BiUser, BiEnvelope, BiHome, BiLogOut } from "react-icons/bi";
import { useNavigate } from "react-router";

import { Stack, Text, Box } from "@chakra-ui/react";
import { useSuspenseQuery } from "@tanstack/react-query";

import { getMeHohishesMeGetOptions } from "@/codegen/openapi2/@tanstack/react-query.gen";
import { CenteredLayout } from "@/components/2/CenteredLayout";
import { AppConfig } from "@/components/app-config";

export const Self = () => {
  const navigate = useNavigate();
  const { data: hohish } = useSuspenseQuery(getMeHohishesMeGetOptions());

  const firstName = hohish.first_name;
  const lastName = hohish.last_name;
  const email = hohish.primary_mail_address;

  return (
    <CenteredLayout maxW="lg">
      <Stack gap="6">
        <Stack gap={{ base: "2", md: "3" }} textAlign="center">
          <Text color="fg.muted" fontWeight="semibold">
            Qui suis-je ?
          </Text>
          <Text color="fg.muted">Voici les informations te concernant dans le système DSIT.</Text>
        </Stack>
      </Stack>

      <Stack
        gap="6"
        borderRadius="md"
        textStyle="sm"
        borderColor="blackAlpha.300"
        borderWidth={1}
        p={6}
      >
        <Stack gap={4}>
          <Box>
            <Stack direction="row" align="center" gap={2} mb={1}>
              <Box as={BiUser} />
              <Text fontWeight="semibold" fontSize="sm" color="gray.600">
                Prénom
              </Text>
            </Stack>
            <Text fontSize="md">{firstName}</Text>
          </Box>

          <Box>
            <Stack direction="row" align="center" gap={2} mb={1}>
              <Box as={BiUser} />
              <Text fontWeight="semibold" fontSize="sm" color="gray.600">
                Nom
              </Text>
            </Stack>
            <Text fontSize="md">{lastName}</Text>
          </Box>

          <Box>
            <Stack direction="row" align="center" gap={2} mb={1}>
              <Box as={BiEnvelope} />
              <Text fontWeight="semibold" fontSize="sm" color="gray.600">
                Adresse e-mail
              </Text>
            </Stack>
            <Text fontSize="md">{email}</Text>
          </Box>
        </Stack>
      </Stack>

      <Text textStyle="sm" color="fg.muted" textAlign="center">
        Ces informations proviennent du système DSIT et sont gérées par l'équipe DSI.
      </Text>

      <Stack direction="row" align="center" justify="center" gap={6} mt={4}>
        <Box
          as="button"
          onClick={() => navigate("/")}
          display="flex"
          alignItems="center"
          gap={2}
          color="fg.muted"
          fontSize="sm"
          cursor="pointer"
          _hover={{ textDecoration: "underline" }}
        >
          <BiHome />
          <Text>Retour à l'accueil</Text>
        </Box>
        <Box
          as="button"
          onClick={AppConfig.logout}
          display="flex"
          alignItems="center"
          gap={2}
          color="fg.muted"
          fontSize="sm"
          cursor="pointer"
          _hover={{ textDecoration: "underline" }}
        >
          <BiLogOut />
          <Text>Se déconnecter</Text>
        </Box>
      </Stack>
    </CenteredLayout>
  );
};
